.row {
  display: flex;
  flex-flow: row wrap;
  min-width: 0;
}
.row.noWrap {
  flex-wrap: nowrap;
}
.row.justifyStart {
  justify-content: flex-start;
}
.row.justifyCenter {
  justify-content: center;
}
.row.justifyEnd {
  justify-content: flex-end;
}
.row.justifySpaceBetween {
  justify-content: space-between;
}
.row.justifySpaceAround {
  justify-content: space-around;
}
.row.justifySpaceEvenly {
  justify-content: space-evenly;
}
.row.alignTop {
  align-items: flex-start;
}
.row.alignMiddle {
  align-items: center;
}
.row.alignBottom {
  align-items: flex-end;
}
.col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
}
.col.generalSpan0 {
  display: none;
}
.col.generalOffset0 {
  margin-left: 0;
}
.col.generalSpan1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}
.col.generalOffset1 {
  margin-left: 4.16666667%;
}
.col.generalSpan2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.col.generalOffset2 {
  margin-left: 8.33333333%;
}
.col.generalSpan3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
.col.generalOffset3 {
  margin-left: 12.5%;
}
.col.generalSpan4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.col.generalOffset4 {
  margin-left: 16.66666667%;
}
.col.generalSpan5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}
.col.generalOffset5 {
  margin-left: 20.83333333%;
}
.col.generalSpan6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}
.col.generalOffset6 {
  margin-left: 25%;
}
.col.generalSpan7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}
.col.generalOffset7 {
  margin-left: 29.16666667%;
}
.col.generalSpan8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.col.generalOffset8 {
  margin-left: 33.33333333%;
}
.col.generalSpan9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}
.col.generalOffset9 {
  margin-left: 37.5%;
}
.col.generalSpan10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.col.generalOffset10 {
  margin-left: 41.66666667%;
}
.col.generalSpan11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}
.col.generalOffset11 {
  margin-left: 45.83333333%;
}
.col.generalSpan12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.col.generalOffset12 {
  margin-left: 50%;
}
.col.generalSpan13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}
.col.generalOffset13 {
  margin-left: 54.16666667%;
}
.col.generalSpan14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.col.generalOffset14 {
  margin-left: 58.33333333%;
}
.col.generalSpan15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}
.col.generalOffset15 {
  margin-left: 62.5%;
}
.col.generalSpan16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.col.generalOffset16 {
  margin-left: 66.66666667%;
}
.col.generalSpan17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}
.col.generalOffset17 {
  margin-left: 70.83333333%;
}
.col.generalSpan18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}
.col.generalOffset18 {
  margin-left: 75%;
}
.col.generalSpan19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}
.col.generalOffset19 {
  margin-left: 79.16666667%;
}
.col.generalSpan20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.col.generalOffset20 {
  margin-left: 83.33333333%;
}
.col.generalSpan21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}
.col.generalOffset21 {
  margin-left: 87.5%;
}
.col.generalSpan22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.col.generalOffset22 {
  margin-left: 91.66666667%;
}
.col.generalSpan23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}
.col.generalOffset23 {
  margin-left: 95.83333333%;
}
.col.generalSpan24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}
.col.generalOffset24 {
  margin-left: 100%;
}
.col.sizeSpanXS0 {
  display: none;
}
.col.sizeOffsetXS0 {
  margin-left: 0;
}
.col.sizeSpanXs1 {
  display: block;
  flex: 0 0 4.16666667%;
  max-width: 4.16666667%;
}
.col.sizeOffsetXs1 {
  margin-left: 4.16666667%;
}
.col.sizeSpanXs2 {
  display: block;
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.col.sizeOffsetXs2 {
  margin-left: 8.33333333%;
}
.col.sizeSpanXs3 {
  display: block;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}
.col.sizeOffsetXs3 {
  margin-left: 12.5%;
}
.col.sizeSpanXs4 {
  display: block;
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.col.sizeOffsetXs4 {
  margin-left: 16.66666667%;
}
.col.sizeSpanXs5 {
  display: block;
  flex: 0 0 20.83333333%;
  max-width: 20.83333333%;
}
.col.sizeOffsetXs5 {
  margin-left: 20.83333333%;
}
.col.sizeSpanXs6 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}
.col.sizeOffsetXs6 {
  margin-left: 25%;
}
.col.sizeSpanXs7 {
  display: block;
  flex: 0 0 29.16666667%;
  max-width: 29.16666667%;
}
.col.sizeOffsetXs7 {
  margin-left: 29.16666667%;
}
.col.sizeSpanXs8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.col.sizeOffsetXs8 {
  margin-left: 33.33333333%;
}
.col.sizeSpanXs9 {
  display: block;
  flex: 0 0 37.5%;
  max-width: 37.5%;
}
.col.sizeOffsetXs9 {
  margin-left: 37.5%;
}
.col.sizeSpanXs10 {
  display: block;
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.col.sizeOffsetXs10 {
  margin-left: 41.66666667%;
}
.col.sizeSpanXs11 {
  display: block;
  flex: 0 0 45.83333333%;
  max-width: 45.83333333%;
}
.col.sizeOffsetXs11 {
  margin-left: 45.83333333%;
}
.col.sizeSpanXs12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.col.sizeOffsetXs12 {
  margin-left: 50%;
}
.col.sizeSpanXs13 {
  display: block;
  flex: 0 0 54.16666667%;
  max-width: 54.16666667%;
}
.col.sizeOffsetXs13 {
  margin-left: 54.16666667%;
}
.col.sizeSpanXs14 {
  display: block;
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.col.sizeOffsetXs14 {
  margin-left: 58.33333333%;
}
.col.sizeSpanXs15 {
  display: block;
  flex: 0 0 62.5%;
  max-width: 62.5%;
}
.col.sizeOffsetXs15 {
  margin-left: 62.5%;
}
.col.sizeSpanXs16 {
  display: block;
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.col.sizeOffsetXs16 {
  margin-left: 66.66666667%;
}
.col.sizeSpanXs17 {
  display: block;
  flex: 0 0 70.83333333%;
  max-width: 70.83333333%;
}
.col.sizeOffsetXs17 {
  margin-left: 70.83333333%;
}
.col.sizeSpanXs18 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}
.col.sizeOffsetXs18 {
  margin-left: 75%;
}
.col.sizeSpanXs19 {
  display: block;
  flex: 0 0 79.16666667%;
  max-width: 79.16666667%;
}
.col.sizeOffsetXs19 {
  margin-left: 79.16666667%;
}
.col.sizeSpanXs20 {
  display: block;
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.col.sizeOffsetXs20 {
  margin-left: 83.33333333%;
}
.col.sizeSpanXs21 {
  display: block;
  flex: 0 0 87.5%;
  max-width: 87.5%;
}
.col.sizeOffsetXs21 {
  margin-left: 87.5%;
}
.col.sizeSpanXs22 {
  display: block;
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.col.sizeOffsetXs22 {
  margin-left: 91.66666667%;
}
.col.sizeSpanXs23 {
  display: block;
  flex: 0 0 95.83333333%;
  max-width: 95.83333333%;
}
.col.sizeOffsetXs23 {
  margin-left: 95.83333333%;
}
.col.sizeSpanXs24 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}
.col.sizeOffsetXs24 {
  margin-left: 100%;
}

@media (width >= 576px) {
  .col.sizeSpanSm0 {
    display: none;
  }
  .col.sizeOffsetSm0 {
    margin-left: 0;
  }
  .col.sizeSpanSm1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .col.sizeSpanSm2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col.sizeSpanSm3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .col.sizeSpanSm4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col.sizeSpanSm5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .col.sizeSpanSm6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col.sizeSpanSm7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .col.sizeSpanSm8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col.sizeSpanSm9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .col.sizeSpanSm10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col.sizeSpanSm11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .col.sizeSpanSm12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col.sizeSpanSm13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .col.sizeSpanSm14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col.sizeSpanSm15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .col.sizeSpanSm16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col.sizeSpanSm17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .col.sizeSpanSm18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col.sizeSpanSm19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .col.sizeSpanSm20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col.sizeSpanSm21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .col.sizeSpanSm22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col.sizeSpanSm23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .col.sizeSpanSm24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col.sizeOffsetSm1 {
    margin-left: 4.16666667%;
  }
  .col.sizeOffsetSm2 {
    margin-left: 8.33333333%;
  }
  .col.sizeOffsetSm3 {
    margin-left: 12.5%;
  }
  .col.sizeOffsetSm4 {
    margin-left: 16.66666667%;
  }
  .col.sizeOffsetSm5 {
    margin-left: 20.83333333%;
  }
  .col.sizeOffsetSm6 {
    margin-left: 25%;
  }
  .col.sizeOffsetSm7 {
    margin-left: 29.16666667%;
  }
  .col.sizeOffsetSm8 {
    margin-left: 33.33333333%;
  }
  .col.sizeOffsetSm9 {
    margin-left: 37.5%;
  }
  .col.sizeOffsetSm10 {
    margin-left: 41.66666667%;
  }
  .col.sizeOffsetSm11 {
    margin-left: 45.83333333%;
  }
  .col.sizeOffsetSm12 {
    margin-left: 50%;
  }
  .col.sizeOffsetSm13 {
    margin-left: 54.16666667%;
  }
  .col.sizeOffsetSm14 {
    margin-left: 58.33333333%;
  }
  .col.sizeOffsetSm15 {
    margin-left: 62.5%;
  }
  .col.sizeOffsetSm16 {
    margin-left: 66.66666667%;
  }
  .col.sizeOffsetSm17 {
    margin-left: 70.83333333%;
  }
  .col.sizeOffsetSm18 {
    margin-left: 75%;
  }
  .col.sizeOffsetSm19 {
    margin-left: 79.16666667%;
  }
  .col.sizeOffsetSm20 {
    margin-left: 83.33333333%;
  }
  .col.sizeOffsetSm21 {
    margin-left: 87.5%;
  }
  .col.sizeOffsetSm22 {
    margin-left: 91.66666667%;
  }
  .col.sizeOffsetSm23 {
    margin-left: 95.83333333%;
  }
  .col.sizeOffsetSm24 {
    margin-left: 100%;
  }
}

@media (width >= 768px) {
  .col.sizeSpanMd0 {
    display: none;
  }
  .col.sizeOffsetMd0 {
    margin-left: 0;
  }
  .col.sizeSpanMd1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .col.sizeSpanMd2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col.sizeSpanMd3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .col.sizeSpanMd4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col.sizeSpanMd5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .col.sizeSpanMd6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col.sizeSpanMd7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .col.sizeSpanMd8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col.sizeSpanMd9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .col.sizeSpanMd10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col.sizeSpanMd11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .col.sizeSpanMd12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col.sizeSpanMd13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .col.sizeSpanMd14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col.sizeSpanMd15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .col.sizeSpanMd16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col.sizeSpanMd17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .col.sizeSpanMd18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col.sizeSpanMd19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .col.sizeSpanMd20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col.sizeSpanMd21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .col.sizeSpanMd22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col.sizeSpanMd23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .col.sizeSpanMd24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col.sizeOffsetMd1 {
    margin-left: 4.16666667%;
  }
  .col.sizeOffsetMd2 {
    margin-left: 8.33333333%;
  }
  .col.sizeOffsetMd3 {
    margin-left: 12.5%;
  }
  .col.sizeOffsetMd4 {
    margin-left: 16.66666667%;
  }
  .col.sizeOffsetMd5 {
    margin-left: 20.83333333%;
  }
  .col.sizeOffsetMd6 {
    margin-left: 25%;
  }
  .col.sizeOffsetMd7 {
    margin-left: 29.16666667%;
  }
  .col.sizeOffsetMd8 {
    margin-left: 33.33333333%;
  }
  .col.sizeOffsetMd9 {
    margin-left: 37.5%;
  }
  .col.sizeOffsetMd10 {
    margin-left: 41.66666667%;
  }
  .col.sizeOffsetMd11 {
    margin-left: 45.83333333%;
  }
  .col.sizeOffsetMd12 {
    margin-left: 50%;
  }
  .col.sizeOffsetMd13 {
    margin-left: 54.16666667%;
  }
  .col.sizeOffsetMd14 {
    margin-left: 58.33333333%;
  }
  .col.sizeOffsetMd15 {
    margin-left: 62.5%;
  }
  .col.sizeOffsetMd16 {
    margin-left: 66.66666667%;
  }
  .col.sizeOffsetMd17 {
    margin-left: 70.83333333%;
  }
  .col.sizeOffsetMd18 {
    margin-left: 75%;
  }
  .col.sizeOffsetMd19 {
    margin-left: 79.16666667%;
  }
  .col.sizeOffsetMd20 {
    margin-left: 83.33333333%;
  }
  .col.sizeOffsetMd21 {
    margin-left: 87.5%;
  }
  .col.sizeOffsetMd22 {
    margin-left: 91.66666667%;
  }
  .col.sizeOffsetMd23 {
    margin-left: 95.83333333%;
  }
  .col.sizeOffsetMd24 {
    margin-left: 100%;
  }
}

@media (width >= 992px) {
  .col.sizeSpanLg0 {
    display: none;
  }
  .col.sizeOffsetLg0 {
    margin-left: 0;
  }
  .col.sizeSpanLg1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .col.sizeSpanLg2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col.sizeSpanLg3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .col.sizeSpanLg4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col.sizeSpanLg5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .col.sizeSpanLg6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col.sizeSpanLg7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .col.sizeSpanLg8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col.sizeSpanLg9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .col.sizeSpanLg10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col.sizeSpanLg11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .col.sizeSpanLg12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col.sizeSpanLg13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .col.sizeSpanLg14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col.sizeSpanLg15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .col.sizeSpanLg16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col.sizeSpanLg17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .col.sizeSpanLg18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col.sizeSpanLg19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .col.sizeSpanLg20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col.sizeSpanLg21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .col.sizeSpanLg22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col.sizeSpanLg23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .col.sizeSpanLg24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col.sizeOffsetLg1 {
    margin-left: 4.16666667%;
  }
  .col.sizeOffsetLg2 {
    margin-left: 8.33333333%;
  }
  .col.sizeOffsetLg3 {
    margin-left: 12.5%;
  }
  .col.sizeOffsetLg4 {
    margin-left: 16.66666667%;
  }
  .col.sizeOffsetLg5 {
    margin-left: 20.83333333%;
  }
  .col.sizeOffsetLg6 {
    margin-left: 25%;
  }
  .col.sizeOffsetLg7 {
    margin-left: 29.16666667%;
  }
  .col.sizeOffsetLg8 {
    margin-left: 33.33333333%;
  }
  .col.sizeOffsetLg9 {
    margin-left: 37.5%;
  }
  .col.sizeOffsetLg10 {
    margin-left: 41.66666667%;
  }
  .col.sizeOffsetLg11 {
    margin-left: 45.83333333%;
  }
  .col.sizeOffsetLg12 {
    margin-left: 50%;
  }
  .col.sizeOffsetLg13 {
    margin-left: 54.16666667%;
  }
  .col.sizeOffsetLg14 {
    margin-left: 58.33333333%;
  }
  .col.sizeOffsetLg15 {
    margin-left: 62.5%;
  }
  .col.sizeOffsetLg16 {
    margin-left: 66.66666667%;
  }
  .col.sizeOffsetLg17 {
    margin-left: 70.83333333%;
  }
  .col.sizeOffsetLg18 {
    margin-left: 75%;
  }
  .col.sizeOffsetLg19 {
    margin-left: 79.16666667%;
  }
  .col.sizeOffsetLg20 {
    margin-left: 83.33333333%;
  }
  .col.sizeOffsetLg21 {
    margin-left: 87.5%;
  }
  .col.sizeOffsetLg22 {
    margin-left: 91.66666667%;
  }
  .col.sizeOffsetLg23 {
    margin-left: 95.83333333%;
  }
  .col.sizeOffsetLg24 {
    margin-left: 100%;
  }
}

@media (width >= 1200px) {
  .col.sizeSpanXl0 {
    display: none;
  }
  .col.sizeOffsetXl0 {
    margin-left: 0;
  }
  .col.sizeSpanXl1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .col.sizeSpanXl2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col.sizeSpanXl3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .col.sizeSpanXl4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col.sizeSpanXl5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .col.sizeSpanXl6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col.sizeSpanXl7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .col.sizeSpanXl8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col.sizeSpanXl9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .col.sizeSpanXl10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col.sizeSpanXl11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .col.sizeSpanXl12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col.sizeSpanXl13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .col.sizeSpanXl14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col.sizeSpanXl15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .col.sizeSpanXl16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col.sizeSpanXl17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .col.sizeSpanXl18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col.sizeSpanXl19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .col.sizeSpanXl20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col.sizeSpanXl21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .col.sizeSpanXl22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col.sizeSpanXl23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .col.sizeSpanXl24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col.sizeOffsetXl1 {
    margin-left: 4.16666667%;
  }
  .col.sizeOffsetXl2 {
    margin-left: 8.33333333%;
  }
  .col.sizeOffsetXl3 {
    margin-left: 12.5%;
  }
  .col.sizeOffsetXl4 {
    margin-left: 16.66666667%;
  }
  .col.sizeOffsetXl5 {
    margin-left: 20.83333333%;
  }
  .col.sizeOffsetXl6 {
    margin-left: 25%;
  }
  .col.sizeOffsetXl7 {
    margin-left: 29.16666667%;
  }
  .col.sizeOffsetXl8 {
    margin-left: 33.33333333%;
  }
  .col.sizeOffsetXl9 {
    margin-left: 37.5%;
  }
  .col.sizeOffsetXl10 {
    margin-left: 41.66666667%;
  }
  .col.sizeOffsetXl11 {
    margin-left: 45.83333333%;
  }
  .col.sizeOffsetXl12 {
    margin-left: 50%;
  }
  .col.sizeOffsetXl13 {
    margin-left: 54.16666667%;
  }
  .col.sizeOffsetXl14 {
    margin-left: 58.33333333%;
  }
  .col.sizeOffsetXl15 {
    margin-left: 62.5%;
  }
  .col.sizeOffsetXl16 {
    margin-left: 66.66666667%;
  }
  .col.sizeOffsetXl17 {
    margin-left: 70.83333333%;
  }
  .col.sizeOffsetXl18 {
    margin-left: 75%;
  }
  .col.sizeOffsetXl19 {
    margin-left: 79.16666667%;
  }
  .col.sizeOffsetXl20 {
    margin-left: 83.33333333%;
  }
  .col.sizeOffsetXl21 {
    margin-left: 87.5%;
  }
  .col.sizeOffsetXl22 {
    margin-left: 91.66666667%;
  }
  .col.sizeOffsetXl23 {
    margin-left: 95.83333333%;
  }
  .col.sizeOffsetXl24 {
    margin-left: 100%;
  }
}

@media (width >= 1600px) {
  .col.sizeSpanXxl0 {
    display: none;
  }
  .col.sizeOffsetXxl0 {
    margin-left: 0;
  }
  .col.sizeSpanXxl1 {
    display: block;
    flex: 0 0 4.16666667%;
    max-width: 4.16666667%;
  }
  .col.sizeSpanXxl2 {
    display: block;
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col.sizeSpanXxl3 {
    display: block;
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .col.sizeSpanXxl4 {
    display: block;
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col.sizeSpanXxl5 {
    display: block;
    flex: 0 0 20.83333333%;
    max-width: 20.83333333%;
  }
  .col.sizeSpanXxl6 {
    display: block;
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col.sizeSpanXxl7 {
    display: block;
    flex: 0 0 29.16666667%;
    max-width: 29.16666667%;
  }
  .col.sizeSpanXxl8 {
    display: block;
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col.sizeSpanXxl9 {
    display: block;
    flex: 0 0 37.5%;
    max-width: 37.5%;
  }
  .col.sizeSpanXxl10 {
    display: block;
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col.sizeSpanXxl11 {
    display: block;
    flex: 0 0 45.83333333%;
    max-width: 45.83333333%;
  }
  .col.sizeSpanXxl12 {
    display: block;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col.sizeSpanXxl13 {
    display: block;
    flex: 0 0 54.16666667%;
    max-width: 54.16666667%;
  }
  .col.sizeSpanXxl14 {
    display: block;
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col.sizeSpanXxl15 {
    display: block;
    flex: 0 0 62.5%;
    max-width: 62.5%;
  }
  .col.sizeSpanXxl16 {
    display: block;
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col.sizeSpanXxl17 {
    display: block;
    flex: 0 0 70.83333333%;
    max-width: 70.83333333%;
  }
  .col.sizeSpanXxl18 {
    display: block;
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col.sizeSpanXxl19 {
    display: block;
    flex: 0 0 79.16666667%;
    max-width: 79.16666667%;
  }
  .col.sizeSpanXxl20 {
    display: block;
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col.sizeSpanXxl21 {
    display: block;
    flex: 0 0 87.5%;
    max-width: 87.5%;
  }
  .col.sizeSpanXxl22 {
    display: block;
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col.sizeSpanXxl23 {
    display: block;
    flex: 0 0 95.83333333%;
    max-width: 95.83333333%;
  }
  .col.sizeSpanXxl24 {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col.sizeOffsetXxl1 {
    margin-left: 4.16666667%;
  }
  .col.sizeOffsetXxl2 {
    margin-left: 8.33333333%;
  }
  .col.sizeOffsetXxl3 {
    margin-left: 12.5%;
  }
  .col.sizeOffsetXxl4 {
    margin-left: 16.66666667%;
  }
  .col.sizeOffsetXxl5 {
    margin-left: 20.83333333%;
  }
  .col.sizeOffsetXxl6 {
    margin-left: 25%;
  }
  .col.sizeOffsetXxl7 {
    margin-left: 29.16666667%;
  }
  .col.sizeOffsetXxl8 {
    margin-left: 33.33333333%;
  }
  .col.sizeOffsetXxl9 {
    margin-left: 37.5%;
  }
  .col.sizeOffsetXxl10 {
    margin-left: 41.66666667%;
  }
  .col.sizeOffsetXxl11 {
    margin-left: 45.83333333%;
  }
  .col.sizeOffsetXxl12 {
    margin-left: 50%;
  }
  .col.sizeOffsetXxl13 {
    margin-left: 54.16666667%;
  }
  .col.sizeOffsetXxl14 {
    margin-left: 58.33333333%;
  }
  .col.sizeOffsetXxl15 {
    margin-left: 62.5%;
  }
  .col.sizeOffsetXxl16 {
    margin-left: 66.66666667%;
  }
  .col.sizeOffsetXxl17 {
    margin-left: 70.83333333%;
  }
  .col.sizeOffsetXxl18 {
    margin-left: 75%;
  }
  .col.sizeOffsetXxl19 {
    margin-left: 79.16666667%;
  }
  .col.sizeOffsetXxl20 {
    margin-left: 83.33333333%;
  }
  .col.sizeOffsetXxl21 {
    margin-left: 87.5%;
  }
  .col.sizeOffsetXxl22 {
    margin-left: 91.66666667%;
  }
  .col.sizeOffsetXxl23 {
    margin-left: 95.83333333%;
  }
  .col.sizeOffsetXxl24 {
    margin-left: 100%;
  }
}
